/**
 * 
 * key
 * 
 */


const key = 'b3RoZXJCcmFuY2hEYXRhUGVuZGluZ1JlcG9ydA=='

export default key 